// Wishlist Api Script

var WishlistGlobalFunction = (function($){

  const conf = {
    app_url : 'http://manicthemes.com/Wishlist-bliss-v2/public',//App Url
    api_endpoints : { //Api Endpoints
      add : '/api/shopify-wishlist-add', // Item Add Api
      get : '/api/shopify-wishlists?user_id=', // Get Items Api
      remove : '/api/shopify-wishlist-remove', // Item Remove Api
      all : '/api/shopify-wishlist-add-all' // Add Multiple Items Api
    },
    key : 'wishlists', // LocalStorage Key
    u_id : customerId, // User ID
    wishlist_btn_class : 'product-item-wishlist',
    wishlist_btn_active_class : 'added-wishlist',
    wishlist_count_id : 'wishlist-count',
    wishlist_items_id : 'wishlist-items'
  };
  const user_id = conf['u_id']

  // Onload wishlist init
  document.addEventListener("DOMContentLoaded",init);

  // Update logged in users's wishlist onload 
  document.addEventListener("DOMContentLoaded",updateOnloadWishlisData);

  // Update Icons Event init
  document.addEventListener("update:wishlist:icons",init);

  /**
   * @method init
   * @description For init wishlist
  */
  function init(){
  
    // Bind Event
    bindEventToWishlistIcons();

    // Update Wishlist Icons
    updateWishlistIcons();
  }

  /**
   * @method updateOnloadWishlisData
   * @description For migrate users wishlist data from local to DB 
  */
  function updateOnloadWishlisData(){
    const wish_list = getOrSetWishlist();
    if(user_id && wish_list.length > 0){
      fetch(conf['app_url'] + conf['api_endpoints']['all'], {
          method: "POST", // or 'PUT'
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
            wish_list : wish_list,
            user_id : user_id
          }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) { //if success
            // Update Wishlist Icons
            updateWishlistIcons();

            // Reset Localstorage
            getOrSetWishlist([],true);
          }
        })
        .catch(err => {
          window.alert("Something Went Wrong !");
        });  
    }
  }

  /**
   * @method bindEventToWishlistIcons
   * @description For bind click event to wishlist icons 
  */
  function bindEventToWishlistIcons(){
    // Binding events to buttons
    const attr_name = 'data-wishlist';
    const btns = $(`.${conf['wishlist_btn_class']}`).not(`[${attr_name}="true"]`);
    
    let btnsToClick = btns;
    if(window.location.href.includes('/search?q'))  {
      btnsToClick = btns.prevObject;
      btnsToClick.off('click');
    }
    $(btnsToClick).click(function(){
       addWhislist(
           $(this).attr( "data-id" ),
           $(this).attr( "data-title" ),
           $(this).attr( "data-url" ),
           $(this).attr( "data-img_url" ),
           $(this).attr( "data-price" ),
           $(this).attr( "data-type" ),
           $(this).attr( "data-variant_id" ),
           $(this).attr( "data-variant_name" ),
           $(this).attr( "data-handle" )
       );
    });

    // Update Attribute
    $(btnsToClick).attr(`${attr_name}`,'true');
  }

  /**
   * @method getOrSetWishlist
   * @params (array)data, (bool)set
   * @description For get and update wishlist localstorage data 
  */
  function getOrSetWishlist(data = null,set = false){
    if(!set){
      let wish_list = localStorage.getItem(conf['key']);
      return (wish_list) ? JSON.parse(wish_list) : [];
    }else{
      localStorage.setItem(conf['key'], JSON.stringify(data));
    }
  }

  /**
   * @method addWhislist
   * @params (string)product_id, (string)name, (string)url, (string)image_url, (string)price, (string)type, (string)variant_id, (string)variant_name, (string)handle
   * @description Trigger when wishlist button click
  */
  function addWhislist(product_id,name,url,image_url,price,type,variant_id,variant_name,handle) {

    let add_wishlist_id = null;
    add_wishlist_id = (variant_id) ? variant_id : product_id;
    const addWishlistButton=document.getElementById("add_wishlist_"+add_wishlist_id);
    const v_btn = document.querySelectorAll("#add_wishlist_"+add_wishlist_id);

    // If button contains added-wishlist class
    if( addWishlistButton.classList.contains(conf['wishlist_btn_active_class'])) {
      // Remove Item From Wishlist
      if(!user_id){
        // If user not logged in
        let wish_list = getOrSetWishlist();
        let obj_key = (variant_id) ? 'variant_id' : 'product_id';
        wish_list.every(function(item,index){
          if(item[obj_key] == add_wishlist_id) {
            wish_list.splice(index, 1); 
            return false;
          }
          return true;
        });

        // Update Local Storage Wishlist Items
        getOrSetWishlist(wish_list,true);

        // Update Icon Status
        updateWishlistIconsStatus(add_wishlist_id,null,true);

        // Update Wishlist Count
        updateWishlistCount(null,false);
      }else{
        // If user logged in
        const itemId =  $(addWishlistButton).attr('data-itemid');

        // Removing Item From Wishlist
        removeWhislistProduct(itemId,user_id,false,add_wishlist_id);
      }
    }else{
      // Add Item To Wishlist
      let cookieObj = {};
      let formData = new FormData();
      let metafields = {};
      let badges = $("#badges_"+product_id).text();
      let pre_orders = $("#pre_orders_"+product_id).text();
      let size_chart = $("#size_charts_"+product_id).text();

      // If variant id undefind
      if(!variant_id){
        type = 'product';
        variant_id = null;
        variant_name = null;
      }

      // Updating Metafield Data
      metafields['badges'] = (badges) ? JSON.parse(badges) : [];
      metafields['pre_orders'] = (pre_orders) ? JSON.parse(pre_orders) : [];
      metafields['size_chart'] = (size_chart) ? JSON.parse(size_chart) : [];
      metafields = JSON.stringify(metafields);

      //Updating Cookie Object
      cookieObj = {
        product_id,
        user_id,
        name,
        url,
        image_url,
        price,
        type,
        variant_id,
        variant_name,
        handle,
        metafields
      };

      // Updating Wishlist
      if(!user_id){
        // If Non Logged In User
        let wish_list = getOrSetWishlist();
        wish_list.push(cookieObj);

        // Updating Local Storage
        getOrSetWishlist(wish_list,true);

        // Update Icon Status
        updateWishlistIconsStatus(add_wishlist_id);

        // Update Wishlist Count
        updateWishlistCount(null);
      }else{
        // If Logged In User

        // Updating Form Data
        for(let c_o in cookieObj){
          formData.append(c_o, cookieObj[c_o]);
        }

        // Update Api Call
        addAPICall(formData,add_wishlist_id);
      }

      document.dispatchEvent(new CustomEvent("wl:item:added", {
        detail: { product : cookieObj }
      }));
    }
  }

  /**
   * @method addAPICall
   * @params (Form Data) wishlistData
   * @description For update logged in user wishlist
  */
  async function addAPICall(wishlistData = null,id = null){
     if(!wishlistData) return;
     const response = await fetch(conf['app_url'] + conf['api_endpoints']['add'], {
        method: 'POST',
        contentType: 'multipart/form-data',
        processData: false,
        body: wishlistData
    });
    const data = await response.json(); //response
    if (data.status){
      // Update Icon Status
      updateWishlistIconsStatus(id,data.item_id);

      // Update Wishlist Count
      updateWishlistCount(null);
    }else{
      window.alert("Something Went Wrong !");
    }
  }

  /**
   * @method removeWhislistProduct
   * @params (string) item_id, (string)user_id, (bool)all
   * @description For remove the wishlist item from DB
  */
  async function removeWhislistProduct(item_id = 0, user_id = false, all = false,id = null) {
    let formData = new FormData();
    formData.append('item_id', item_id);
    formData.append('user_id', user_id);
    formData.append('all', all);

    // rest api call
    const response = await fetch(conf['app_url'] + conf['api_endpoints']['remove'], {
        method: 'POST',
        contentType: 'multipart/form-data',
        processData: false,
        body: formData
    });
    const data = await response.json(); //response
    if (data.status) { //if success
      // Update Icon Status
      if(id) updateWishlistIconsStatus(id,null,true);
      
      // Update Wishlist Count
      updateWishlistCount(null,false);
    }
  }

  /**
   * @method updateWishlistIcons
   * @description For get the wishlist items data
  */
  async function updateWishlistIcons(){
    // If user id found
    if(user_id){
      fetch(conf['app_url'] + conf['api_endpoints']['get'] +user_id)
        .then(response => response.json())
        .then(data => {
          const items = data;
          items.wishlist.forEach((item) => {
            const wishlist_added_id = (item.variant_id) ? item.variant_id : item.product_id;
            updateWishlistIconsStatus(wishlist_added_id,item.id);
          });

          //Update Wishlist Count
          updateWishlistCount(items.wishlist.length);

          // For Wishlist Items
          renderWishlistItems(items.wishlist);
        })
        .catch(err => {
          window.alert("Something Went Wrong !");
          console.error(err);
        });    
    }else{
      // If id not found
      const items = getOrSetWishlist();
      items.forEach(function(item){
        const wishlist_added_id = (item.variant_id) ? item.variant_id : item.product_id;
        updateWishlistIconsStatus(wishlist_added_id);
      });

      //Update Wishlist Count
      updateWishlistCount(items.length);

      // For Wishlist Items
      renderWishlistItems(items);
    }
  }

  /**
   * @method updateWishlistIconsStatus
   * @params (string) id, (string)item_id, (bool)remove
   * @description For activate and deactivate wishlist Icons
  */
  function updateWishlistIconsStatus(id = null,item_id = null,remove = false){
    const w_btns = document.querySelectorAll("#add_wishlist_"+id);
    w_btns.forEach(function(w_btn){
      let btn_classlist = w_btn.classList;
      (remove) ? btn_classlist.remove(conf['wishlist_btn_active_class']) : btn_classlist.add(conf['wishlist_btn_active_class']);
      if(item_id) w_btn.setAttribute('data-itemid' , item_id);
      if(remove) w_btn.removeAttribute('data-itemid');
    });
  }

  /**
   * @method updateWishlistCount
   * @params (int)count, (bool) add
   * @description For update Wishlist Count
  */
  function updateWishlistCount(count = null,add = true){
    let count_ele = document.getElementById(conf['wishlist_count_id']);
    // Update Count
    if(count !== null){
      if(count_ele) count_ele.innerHTML = count;
    }else{
      if(count_ele){
        let c = (count_ele.innerHTML) ? parseInt(count_ele.innerHTML) : 0;
        count_ele.innerHTML = (add) ? c + 1 : (c > 0) ? c - 1 : 0;
      }
    }
  }

  /**
   * @method renderWishlistItems
   * @params (array)items
   * @description For Render Wishlist Items On Wishlist Page
  */
  function renderWishlistItems(items = null){
    const wishlist_items_wrap = document.getElementById(conf['wishlist_items_id']);
    if(wishlist_items_wrap && items){
      
      const layout = {// Html Layouts
        getEmptyHtmlLayout(){// Empty Message HTML
          return `
            <div class="empty-wishlist">
              Oops! We can\'t find your wishlist anywhere! Start a new one now!
            </div>
          `;
        },
        getClearAllBtnHtmlLayout(){// Clear All Button HTML
          return `
          <div>
            <a 
              id="" 
              class="remove-all-btn item-remove-btn  Button Button--primary" 
              data-itemid=""  
              data-all="true"
              data-remove-wishlist-item
            > 
              Clear List  (${items.length})
            </a>
          </div>
          `;
        },
        getItemHtmlLayout(){ //Item Layout
          return `
          <div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--lap-and-up whislist-grid">
             <div class="inner-div" style="" id="">
                <button 
                  class="shg-remove-btn item-remove-btn added-wishlist"  
                  style="font-size:15px; float:right" 
                  data-itemid="${this.id}"  
                  data-all="false" 
                  data-remove-wishlist-item
                >
                   <svg class="Icon Icon--wishlist" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 64 64" viewBox="0 0 64 64">
                      <g transform="translate(232 228)">
                         <path fill="#000" d="M-207.5-205.1h3v24h-3zM-201.5-205.1h3v24h-3zM-195.5-205.1h3v24h-3zM-219.5-214.1h39v3h-39z"/>
                         <path fill="#000" d="M-192.6-212.6h-2.8v-3c0-.9-.7-1.6-1.6-1.6h-6c-.9 0-1.6.7-1.6 1.6v3h-2.8v-3c0-2.4 2-4.4 4.4-4.4h6c2.4 0 4.4 2 4.4 4.4v3"/>
                         <path fill="#000" d="M-191-172.1h-18c-2.4 0-4.5-2-4.7-4.4l-2.8-36 3-.2 2.8 36c.1.9.9 1.6 1.7 1.6h18c.9 0 1.7-.8 1.7-1.6l2.8-36 3 .2-2.8 36c-.2 2.5-2.3 4.4-4.7 4.4"/>
                      </g>
                   </svg>
                </button>
                <a class="shogun-image-link" href="${this.url}">
                <img src="https:${this.image_url}" width="400" height="400" style="" alt="" class="shogun-image ">
                </a>
                <div class="product-variant-card">
                   <p class="variant_color-option">
                     <a id="" class="product-name " href="${this.url}" style="font-size:15px;">
                       ${this.product_name }
                     </a>
                   </p>
                   <div class="ProductItem__PriceList">
                      <p class="Price"> 
                        ${"Rs. " + convertPaisaToInr(this.price)}
                      </p>
                   </div>
                   <button 
                     data-product='${this.product_id}' 
                     data-variant='${this.variant_id ? this.variant_id : ''}' 
                     data-handle = '${this.handle}' 
                     data-itemid="${this.id}" 
                     data-user="${this.user_id}" 
                     data-meta='${this.metafields}' 
                     class="Button Button--small wishlist__add__to__bag" 
                     data-move-to-bag
                     onclick="wishlistToBag(this)"
                    >
                       Move to Bag
                    </button>
                </div>
             </div>
          </div>
          `;
        },
        getItemsOuterLayout(inner_html = null){ //Item Outer HTML Layout
          return `
            <div class="ProductList Grid featured-product-variant" data-mobile-count="2" data-desktop-count="3">
              ${inner_html}
            </div>
          `;
        }
      };
      let html = '';
      let items_html = '';

      // Clear All Button
      html = html.concat(layout.getClearAllBtnHtmlLayout());

      // Wishlist Items Loop
      items.forEach(function(item,item_index){
        if(!user_id){
          item.id = item_index;
          item.product_name = item.name;
        }
        items_html = items_html.concat(layout.getItemHtmlLayout.call(item));
      });
      html = html.concat(layout.getItemsOuterLayout(items_html));

      // Update Html
      wishlist_items_wrap.innerHTML = (items.length > 0) ? html : layout.getEmptyHtmlLayout();

      // Update Wishlist Remove Buttons On Wishlist Page
      updateWishlistItemRemoveBtns();
    }
  }

  /**
   * @method updateWishlistItemRemoveBtns
   * @description For update wishlist item remove buttons
  */
  function updateWishlistItemRemoveBtns(){
    const remove_btns = document.querySelectorAll('[data-remove-wishlist-item]');
    remove_btns.forEach(function(r_b){
      r_b.onclick = async function(){
        let item_id = this.getAttribute('data-itemid');
        let all = this.getAttribute('data-all');

        if(user_id){// If user logged in
          
          // Remove Item From Wishlist
          await removeWhislistProduct(item_id,user_id,all);
          
        }else{// If user not logged in
          let wishlist_items = getOrSetWishlist();
          if(all == 'true'){
            // Update Local Storage
            getOrSetWishlist([],true);
          }else{
            // Update Local Storage
            wishlist_items.splice(item_id, 1); 
            getOrSetWishlist(wishlist_items,true);
          }
        }
        // Update Wishlist
        updateWishlistIcons();
      }
    });
  }

  return {
    init: init
  }
}(jQuery));